export const useLeadsFunnelsHeader = () => {
  return {};
};
